import { render, staticRenderFns } from "./OverlayCenterIcon.vue?vue&type=template&id=73fa5fcc&"
import script from "./OverlayCenterIcon.vue?vue&type=script&lang=js&"
export * from "./OverlayCenterIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports